var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm-group" },
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-firm-group-basedata", {
            attrs: {
              cols: 12,
              "form-context": _vm.initialFormContexts.firmGroupBasedata,
              "is-creation-form": true,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }